// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfServiceDialog_root__TtXeT","heroContainer":"TermsOfServiceDialog_heroContainer__AfHkz","hero":"TermsOfServiceDialog_hero___xgjc"};